export default "__VITE_ASSET__e1d26b2d__"